import { createGlobalStyle } from 'styled-components';
import Fonts, { Font, FontWeight } from '../utils/fonts';
import Color from '../utils/colors';

const GlobalStyles = createGlobalStyle`
    ${Fonts}

    body {
        ${Font.PRIMARY};
        ${FontWeight.REGULAR};
        color: ${Color.TEXT_PRIMARY};

        margin: 0;
        
        //background: linear-gradient(180deg, #000D2E 0%, #001B60 100%);
    }

    html {
        box-sizing: border-box;
    }

    *, *:before, *:after {
        box-sizing: inherit;
    }
    
    //html, body {
    //    overflow-x: hidden;
    //}
`;

export default GlobalStyles;
